import React, { memo } from 'react';

const Divider = () => <div className="filter-divider" />;

export default memo(Divider);
